export default __webpack_public_path__ + "static/media/crossNormal.60d87732.svg";